import React, { memo } from 'react';
import { ShieldAlert, Zap } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-119">
      {/* Abstract background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-amber-900/5 to-transparent pointer-events-none" data-id="element-120"></div>

      <div className="max-w-4xl mx-auto" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <span className="text-amber-500 text-sm tracking-widest uppercase mb-4 block" data-id="element-123">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-zinc-100 mb-6" data-id="element-124">
            Soberanía Emocional Radical
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-125">
          <div className="space-y-6" data-id="element-126">
            <div className="flex items-center gap-4 mb-2" data-id="element-127">
              <ShieldAlert className="w-6 h-6 text-amber-500" data-id="element-128" />
              <h3 className="text-2xl font-serif text-zinc-100" data-id="element-129">La Misión</h3>
            </div>
            <p className="text-lg text-zinc-400 leading-relaxed" data-id="element-130">
              El cierre es una decisión{' '}
              <strong className="text-zinc-200 font-normal" data-id="element-131">unilateral</strong>.
              No necesitas que la otra persona esté presente, ni arrepentida, ni
              siquiera viva. Tu paz no requiere su permiso.
            </p>
          </div>

          <div className="space-y-6" data-id="element-132">
            <div className="flex items-center gap-4 mb-2" data-id="element-133">
              <Zap className="w-6 h-6 text-amber-500" data-id="element-134" />
              <h3 className="text-2xl font-serif text-zinc-100" data-id="element-135">La Técnica</h3>
            </div>
            <div className="bg-zinc-900 p-6 border-l-4 border-amber-500" data-id="element-136">
              <h4 className="text-amber-400 font-medium mb-2" data-id="element-137">
                El Finiquito de Almas
              </h4>
              <p className="text-zinc-300 leading-relaxed" data-id="element-138">
                Recuperamos tus "activos energéticos" congelados en el pasado y
                los movemos a tu abundancia presente. Cortamos el suministro de
                tu energía hacia esa memoria.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}